import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import figma from "../../assets/Images/figma.png";
import lowprot1 from "../../assets/Images/lowfidprot.JPG";
import lowprot2 from "../../assets/Images/lowfidprot1.JPG";
import Slideshow from "../../assets/Slideshow/Slideshow"; 

import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";




const Lo5Reflections = () => {
    const navigate = useNavigate();
    const images = [figma, lowprot1, lowprot2];
    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo5-headings">
                <h1>Reflection</h1>
                <p></p>

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                                    <BreadcrumbHeader />
            </div>
            <div className="content-lo5">
                <div className="content-lo5-reflection">
                    <div className="content-lo5-reflection-text">
                        <h1>Reflection on Personal Growth</h1>
                        <p>
                            At the start of this semester, I was still figuring out how to combine my interest in design with technical tools like Git, React, and Arduino. I was confident with visuals, but less structured with 
                            documentation, workflow, and coding practices. As I progressed, feedback from peers and teachers pushed me to organize my work better, use Git more professionally, and explore new creative tools like Blender.
                            <br></br>
                            This learning process helped me discover that I enjoy building interactive, visual experiences especially when I get to combine design and technology. Developing my personal portfolio in React and working on the
                            3D cat mascot showed me how much I enjoy creative coding and visual storytelling.
                        </p>
                        
                    </div>

                    <div className="content-lo5-reflection-text2">
                        <h1>Decisions on My Future Studies</h1>
                        <p>
                            After experimenting with Cyber Security, I realized that my passion lies in user-centered design and creative technology. That's why I've decided to pursue the Mobile App Development minor next semester.
                            It's a space where I can combine visuals, interactivity, and coding in ways that feel natural to me.
                        </p>
                        
                    </div>

                    <div className="content-lo5-reflection-text3">
                        <h1>My Personal Goals</h1>
                        <p>
                            <ul>
                                <li>
                                    <h3>Become more confident with technical tools</h3>I'm still learning Git, React, and Arduino, but I've made progress and plan to keep improving through personal projects.
                                </li>
                                <li>
                                    <h3>Develop creative, user-focused applications</h3>I aim to create more items that mix aesthetics and usefulness, such as my 3D portfolio and interactive poster.
                                </li>

                            </ul>
                            Reflecting on this semester, I can see how feedback, challenges, and curiosity have helped me improve, and I am more clear about the path I want to take.
                        </p>
                        
                    </div>

                    {/* <div className="content-lo5-reflection-slideshow">
                        <Slideshow images={images} />

                    </div> */}

                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo5Reflections;